"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const kheti_1 = require("../axios/kheti");
const fetchAllVendorsV2 = async (latLng, lang, forCreditOrder, farmerId, accessToken, serviceId) => {
    const headers = new axios_1.AxiosHeaders();
    if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
        headers.set('X-AUTH-SCHEME', 'keycloak');
        headers.set('Access-Control-Allow-Origin', '*');
    }
    try {
        const { vendor_details, dc_is_financed } = await (0, kheti_1.get)('/hyperlocal/v2/availability', {
            lat_lng: latLng,
            lang,
            for_credit_order: forCreditOrder,
            farmer_id: farmerId,
            service_id: serviceId,
        }, headers);
        return { vendor_details: vendor_details, dc_is_financed };
    }
    catch {
        return null;
    }
};
exports.default = fetchAllVendorsV2;
